import {forwardRef} from 'react'
import classNames from 'classnames'

interface MobileBackButtonProps {
  /** The level it returns to, shown after the chevron. */
  label: string
  ariaLabel: string
  onClick: () => void
  dataCy: string
  className?: string
}

/** The cyan "‹ label" back control at the top of every phone pane. */
export const MobileBackButton = forwardRef<
  HTMLButtonElement,
  MobileBackButtonProps
>(({label, ariaLabel, onClick, dataCy, className}, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    data-cy={dataCy}
    // Marks a phone pane, so a rotation can tell it is editing details.
    data-mobile-pane-back=""
    className={classNames(
      'mobile-touch-target flex h-11 max-w-[240px] flex-shrink-0 items-center gap-0.5 overflow-hidden whitespace-nowrap rounded-ds-pill pl-1 pr-3 karla-bold text-type-body text-dope-cyan-bright touch-manipulation',
      'transition-transform duration-fast ease-standard active:scale-95 active:bg-dope-cyan-bright/10 motion-reduce:transition-none',
      className,
    )}
  >
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <path
        d="m14 6-6 6 6 6"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span className="truncate">{label}</span>
  </button>
))

MobileBackButton.displayName = 'MobileBackButton'
